import type { WhitelistItem } from "@gearbox-protocol/cli-utils";
import { Button, Plus } from "@gearbox-protocol/deploy-tools-ui";
import { type FC, type ReactNode, useState } from "react";
import { useLoaderData } from "react-router-dom";
import { useToggle } from "react-use";

import WhitelistCreateDialog from "./WhitelistCreateDialog";
import WhitelistDeleteDialog from "./WhitelistDeleteDialog";
import WhitelistList from "./WhitelistList";

interface WhitelistCategoryViewProps {
  category: string;
  title: string;
  headerActions?: (items: WhitelistItem[]) => ReactNode;
}

const WhitelistCategoryView: FC<WhitelistCategoryViewProps> = ({
  category,
  title,
  headerActions,
}) => {
  const items = useLoaderData() as WhitelistItem[];
  const [createDialogOpen, toggleCreateDialog] = useToggle(false);
  const [deletedItem, setDeletedItem] = useState<WhitelistItem | undefined>();

  return (
    <>
      <div className="flex flex-row gap-2 items-center">
        <h2 className="text-gray-100">{`${title} whitelist`}</h2>
        <Button onClick={toggleCreateDialog} variant="ghost">
          <Plus />
        </Button>
        {headerActions?.(items)}
      </div>

      <WhitelistList items={items} onDelete={setDeletedItem} />

      {createDialogOpen && (
        <WhitelistCreateDialog
          category={category}
          toggleOpen={toggleCreateDialog}
        />
      )}

      {deletedItem && (
        <WhitelistDeleteDialog
          category={category}
          item={deletedItem}
          onClose={() => {
            setDeletedItem(undefined);
          }}
        />
      )}
    </>
  );
};

export default WhitelistCategoryView;
